import { Image, useDeviceType } from '@cian/ui-kit';

const X2_IMAGE_MEDIA_QUERY = '(-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)';

export interface ICommunicationImageProps {
  image: {
    x1: string;
    x2: string;
  };
  testId?: string;
}

export const CommunicationImage: React.FC<ICommunicationImageProps> = ({ image, testId }) => {
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <Image
      sources={[{ media: X2_IMAGE_MEDIA_QUERY, srcset: image.x2 }, { srcset: image.x1 }]}
      src={image.x1}
      height={isDesktop ? 200 : 150}
      width="auto"
      objectFit="contain"
      data-testid={testId}
    />
  );
};

CommunicationImage.displayName = 'CommunicationImage';
